import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  LineContent,
  Circle,
  CardContent,
  CardHeader,
  SimpleCircle,
  Separator,
  GraphBar,
  CardContentCalifications,
  CardContentReports,
  GhaphImgContainer,
  HorizontalSeparator,
  ScoreSection,
  LineDiv,
  ScoreContainer,
  Secondary,
  ButtonDiv
} from './styles';
import Star from '../../assets/icons/skeleton-star.svg';
import Score from '../../assets/icons/Score.svg';

import GhaphImg from '../../assets/img/graph-reports.svg';
import SectionLayout from '../SectionLayout';

const ScoreSkeleton = ({ device }) => {
  const isMobile = device === 'mobile';
  const isTablet = device === 'tablet';
  const isDesktop = device === 'desktop';
  const { t } = useTranslation();

  return (
    <>
      <SectionLayout>
        <ScoreSection>
          <LineContent margin-bottom='20px' height='32px' width='300px' />
          <img src={Score} alt='Score' />
          <LineContent margin-bottom='20px' height='32px' width='300px' />
          <LineContent margin-bottom='20px' height='32px' width='300px' />
        </ScoreSection>
      </SectionLayout>

      <SectionLayout>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>
          {!isMobile && <LineContent width='155px' />}
        </CardHeader>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='100px' />
          </ScoreContainer>
        </CardHeader>
        <LineDiv />

        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>
          <ButtonDiv>
            <Secondary disabled>{t('panel.reputacion.tax.cta2')}</Secondary>
          </ButtonDiv>
        </CardHeader>
        <LineDiv />
        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>
          <ButtonDiv>
            <Secondary disabled>{t('panel.reputacion.tax.cta1')}</Secondary>
          </ButtonDiv>
        </CardHeader>
      </SectionLayout>

      <SectionLayout>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>

          <div>
            <div className='stars-container'>
              <img src={Star} alt='Star' height={16} width={16} />
              <img src={Star} alt='Star' height={16} width={16} />
              <img src={Star} alt='Star' height={16} width={16} />
              <img src={Star} alt='Star' height={16} width={16} />
              <img src={Star} alt='Star' height={16} width={16} />
            </div>
          </div>
        </CardHeader>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='100px' />
          </ScoreContainer>
        </CardHeader>

        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>
        </CardHeader>
      </SectionLayout>

      <SectionLayout>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>
          {!isMobile && <LineContent width='155px' />}
        </CardHeader>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='100px' />
          </ScoreContainer>
          <ButtonDiv>
            <Secondary disabled>{t('panel.reputacion.avisos.publicados.cta')}</Secondary>
          </ButtonDiv>
        </CardHeader>
      </SectionLayout>

      <SectionLayout>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>
          {!isMobile && <SimpleCircle w={65} h={65} isCircular />}
        </CardHeader>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='100px' />
          </ScoreContainer>
        </CardHeader>
      </SectionLayout>

      <SectionLayout>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='200px' />
          </ScoreContainer>
          {!isMobile && <LineContent width='155px' />}
        </CardHeader>
        <CardHeader>
          <ScoreContainer>
            <LineContent width='100px' />
          </ScoreContainer>
        </CardHeader>
      </SectionLayout>
    </>
  );
};

export default ScoreSkeleton;
